// extracted by mini-css-extract-plugin
var _1 = "FieldSet-module__animateUploadProgressBarWidth--dnNbO";
var _2 = "FieldSet-module__animatedBackground--zp9OS";
var _3 = "FieldSet-module__fieldSet--hnzhY";
var _4 = "FieldSet-module__legend--Pvgqa";
var _5 = "FieldSet-module__marginNormal--Xczqe";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "fieldSet", _4 as "legend", _5 as "marginNormal" }
